"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MENU_DATA = exports.TYPE_MAP = exports.TYPE_SCATTERPLOT = exports.TYPE_DONUT = exports.TYPE_PIE = exports.TYPE_LINE = exports.TYPE_STACKED_BAR_HORIZONTAL = exports.TYPE_BAR_HORIZONTAL = exports.TYPE_STACKED_BAR = exports.TYPE_BAR = void 0;
var TYPE_BAR = "bar";
exports.TYPE_BAR = TYPE_BAR;
var TYPE_STACKED_BAR = "stacked-bar";
exports.TYPE_STACKED_BAR = TYPE_STACKED_BAR;
var TYPE_BAR_HORIZONTAL = "bar-horizontal";
exports.TYPE_BAR_HORIZONTAL = TYPE_BAR_HORIZONTAL;
var TYPE_STACKED_BAR_HORIZONTAL = "stacked-bar-horizontal";
exports.TYPE_STACKED_BAR_HORIZONTAL = TYPE_STACKED_BAR_HORIZONTAL;
var TYPE_LINE = "line";
exports.TYPE_LINE = TYPE_LINE;
var TYPE_PIE = "pie";
exports.TYPE_PIE = TYPE_PIE;
var TYPE_DONUT = "donut";
exports.TYPE_DONUT = TYPE_DONUT;
var TYPE_SCATTERPLOT = "scatter";
exports.TYPE_SCATTERPLOT = TYPE_SCATTERPLOT;
var TYPE_MAP = "map";
exports.TYPE_MAP = TYPE_MAP;
var MENU_DATA = [{
  type: TYPE_BAR
}, {
  type: TYPE_STACKED_BAR
}, {
  type: TYPE_BAR_HORIZONTAL
}, {
  type: TYPE_STACKED_BAR_HORIZONTAL
}, {
  type: TYPE_PIE
}, {
  type: TYPE_DONUT
}, {
  type: TYPE_LINE
}, {
  type: TYPE_SCATTERPLOT
}, {
  type: TYPE_MAP
}];
exports.MENU_DATA = MENU_DATA;